import { AustralianStates } from './race';

export function getFlagEmoji(countryCode: string) {
  if (Object.values(AustralianStates).includes(countryCode)) return '🇦🇺';

  if (countryCode === 'IRL') return '🇮🇪';
  if (countryCode === 'SWE') return '🇸🇪';

  //   get the flag emoji from the country code
  const codePoints = countryCode
    .slice(0, 2)
    .toUpperCase()
    .split('')
    .map((char) => 127397 + char.charCodeAt(0));

  return String.fromCodePoint(...codePoints);
}
